import styled from 'styled-components';

export const InputContainer = styled.div`
  width: 100%;
  //height: 100%;
  height: 70px;
  max-height: 120px;
  padding: 8px 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s linear;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently not supported by any browser */
`;
export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eeeeee;
  width: 100%;
  height: 100%;
  padding: 0 5px;
  box-sizing: border-box;
  border-radius: 18px;
`;
export const Input = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  font-size: 15px;
  padding: 4px 0 4px 5px;
  box-sizing: border-box;
  &&:focus {
    outline: none;
  }
`;
export const TextArea = styled.textarea`
  width: 100%;
  height: 100%;
  margin-top: 5px;
  border: none;
  background: transparent;
  font-size: 15px;
  padding: 4px 0 4px 5px;
  box-sizing: border-box;
  resize: none;
  &&:focus {
    outline: none;
  }
`;
export const IconWrapper = styled.div`
  margin-left: 5px;
  height: 100%;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    // width: 30px;
    // height: 30px;
    cursor: pointer;
  }
`;
export const IconWrapperSend = styled.div`
  margin-left: 10px;
  height: 30px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3.8vw;
  color: #fff;
  border-radius: 100px;
  background-color: ${(props) => props.$chatmessagecolor ?? '#AD30E5'};
`;
export const ListWrapper = styled.div`
  background: #ffffff;
  display: flex;
  flex-direction: row;
  position: absolute;
  justify-content: center;
  margin: 0 20px;
  right: 0;
  width: 50vw;
  padding: 0 20px;
  box-sizing: border-box;
  box-shadow: 0 -3px 10px 0 rgba(0, 0, 0, 0.04);
  // opacity: 0.95;
  border-radius: 10px;
  align-items: flex-start;
  flex-direction: column;
  // div:nth-child(1) {
  //   border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  // }

  // div:nth-child(2) {
  //   border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  // }
`;
export const ListItem = styled.div`
  text-align: center;
  padding: 4vw 0;
  box-sizing: border-box;
  font-size: ${(props) => (props.$chatLanguage === 'zh' ? '4vw' : '3vw')};
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;
export const ListCut = styled.div`
  margin: 3vw 10vw;
  width: 1px;
  background-color: rgba(0, 0, 0, 0.1);
`;
